import React from "react";
import styles from "./Stack.module.scss";
import clsx from "clsx";

interface StackProps {
  gap?: string;
  as?: string;
  className?: string;
}

/**
 *
 * Stack
 *
 */
const Stack = ({
  gap = "0",
  as = "div",
  children,
  className = "",
  ...props
}: StackProps) => {
  const Component = as;
  const getGap = (gap: string) => {
    switch (gap) {
      case "1":
        return "gap-1";
      case "2":
        return "gap-2";
      case "3":
        return "gap-3";
      case "4":
        return "gap-4";
      case "5":
        return "gap-5";
      case "6":
        return "gap-6";
      case "8":
        return "gap-8";
      case "10":
        return "gap-10";
      case "12":
        return "gap-12";
      case "16":
        return "gap-16";
      case "20":
        return "gap-20";
      case "24":
        return "gap-24";
      case "32":
        return "gap-32";
      case "40":
        return "gap-40";
      default:
        return "gap-4";
    }
  };
  return (
    <Component
      className={clsx(styles.stack, "grid grid-cols-1", getGap(gap), className)}
    >
      {children}
    </Component>
  );
};

export default Stack;
